import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageClosedCashAccountLayer from "../../../components/Admin/ManageClosedCashAccountLayer";

const ManageClosedCashAccount = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageClosedCashAccountLayer />
      </MasterLayout>
    </>
  );
};

export default ManageClosedCashAccount